import { useState, useEffect, useCallback } from 'react'

export const VIEW_MODES = {
  LIST: 'list',
  TILE: 'tile',
}

const useViewMode = ({
  initialMode = VIEW_MODES.TILE,
  storageKey = '',
  onChangeMode = null,
  classNamePrefix = 'view-mode',
} = {}) => {
  const [viewMode, setViewMode] = useState(() => {
    if (storageKey && typeof window !== 'undefined') {
      const savedMode = localStorage.getItem(storageKey)
      if (savedMode) return savedMode
    }
    return initialMode
  })

  useEffect(() => {
    if (initialMode && !storageKey) {
      setViewMode(initialMode)
    }
  }, [initialMode, storageKey])

  const changeViewMode = useCallback((mode) => {
    setViewMode(mode)
    if (storageKey && typeof window !== 'undefined') {
      localStorage.setItem(storageKey, mode)
    }
    if (typeof onChangeMode === 'function') {
      onChangeMode(mode)
    }
  }, [storageKey, onChangeMode])

  const isList = viewMode === VIEW_MODES.LIST
  const isTile = viewMode === VIEW_MODES.TILE

  return {
    viewMode,
    changeViewMode,
    isList,
    isTile,
    viewModeClass: `${classNamePrefix}-${viewMode}`,
  }
}

export default useViewMode
